import { gql } from "@apollo/client";

export const SPACELIFT_VCS_REPO_BASIC_FRAGMENT = gql`
  fragment SpaceliftVcsRepoBasic on SpaceliftVCS {
    id
    name
    description
    createdAt
    space {
      id
      name
    }
  }
`;
